interface LineOneAndTwo {
	line1: string;
	line2: string;
}

const extractLine2 = (args: LineOneAndTwo): LineOneAndTwo => {
	const { line1, line2 } = args;

	let cleanLine1 = line1.trim();
	let cleanLine2 = line2.trim();

	let stripAtIndex = -1;

	if (cleanLine1.toUpperCase().includes(" UNIT ")) {
		stripAtIndex = cleanLine1.toUpperCase().indexOf(" UNIT ");
	}
	if (cleanLine1.toUpperCase().includes(" #")) {
		stripAtIndex = cleanLine1.toUpperCase().indexOf(" #");
	}
	if (cleanLine1.toUpperCase().includes(" APT ")) {
		stripAtIndex = cleanLine1.toUpperCase().indexOf(" APT ");
	}
	if (cleanLine1.toUpperCase().includes(" APT. ")) {
		stripAtIndex = cleanLine1.toUpperCase().indexOf(" APT. ");
	}
	if (cleanLine1.toUpperCase().includes(" STE ")) {
		stripAtIndex = cleanLine1.toUpperCase().indexOf(" STE ");
	}
	if (cleanLine1.toUpperCase().includes(" STE. ")) {
		stripAtIndex = cleanLine1.toUpperCase().indexOf(" STE. ");
	}
	if (!cleanLine2 && stripAtIndex >= 0) {
		cleanLine2 = cleanLine1.substring(stripAtIndex).trim();
		cleanLine1 = cleanLine1.substring(0, stripAtIndex).trim();
	}

	return {
		line1: cleanLine1,
		line2: cleanLine2,
	};
};

export default extractLine2;
